module.exports = __webpack_public_path__ + "static/media/  (132).0ca14a9a.jpg";